import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "d-flex clickable"
}
const _hoisted_2 = { class: "scope-header" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_breadcrumbs_item = _resolveComponent("v-breadcrumbs-item")!
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "scopeRoot",
    class: _normalizeClass(["font-weight-bold px-3 scope pa-2", { 'disable-pointer-events': _ctx.viewOnly }]),
    id: "scope-btn-open"
  }, [
    (!_ctx.viewOnly)
      ? (_openBlock(), _createBlock(_component_v_icon, {
          key: 0,
          class: _normalizeClass(_ctx.scopeIconStyle)
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode(" mdi-file-tree-outline ", -1)
          ]))]),
          _: 1
        }, 8, ["class"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scopeClick && _ctx.scopeClick(...args)))
    }, [
      (_ctx.items.length)
        ? (_openBlock(), _createBlock(_component_v_breadcrumbs, {
            key: 0,
            class: "scope-header clickable",
            items: _ctx.items
          }, {
            item: _withCtx(({ item }:{item:any}) => [
              _createVNode(_component_v_breadcrumbs_item, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$utils.servertranslate(item.name)), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }, 8, ["items"]))
        : (!_ctx.viewOnly)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t("Scope")), 1)
            ]))
          : _createCommentVNode("", true)
    ])
  ], 2))
}